import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { updatedata } from "../../util/global";
import { customerdef } from './Datatype';

const ReveenSignup = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  // const [pin, setPin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      const response = await fetch('/signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...customerdef,
          email,
          phone,
          password,
          name: name,
          _adminuserid: window.APPSETTING.adminuserid,
          appname: window.APPSETTING.appname
        }),
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || data.error || 'Signup failed');
      }

      window.APPUSER = data;
      localStorage.setItem(window.APPSETTING.appname + "user", JSON.stringify(data));

      navigate('/subscriptions');
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <div className="page-card" style={{ maxWidth: '400px', margin: '3rem auto' }}>
      <div className="eyebrow">CREATE ACCOUNT</div>
      <h2 style={{ fontFamily: 'var(--display)', fontSize: '1.9rem', fontWeight: 800, letterSpacing: '-0.03em', margin: '0 0 20px' }}>Reveen Signup</h2>
      {error && <div style={{ color: 'var(--danger)', fontSize: '0.8rem', margin: '0 0 14px' }}>{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="fg">
          <label style={{ color: 'var(--cust-muted)' }}>Full Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div className="fg">
          <label style={{ color: 'var(--cust-muted)' }}>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="fg">
          <label style={{ color: 'var(--cust-muted)' }}>Mobile Phone</label>
          <input
            type="text"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
        </div>
        {/* <div className="fg">
          <label style={{ color: 'var(--cust-muted)' }}>Pin Code</label>
          <input
            type="text"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            required
          />
        </div> */}
        <div className="fg">
          <label style={{ color: 'var(--cust-muted)' }}>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="btn-blue" style={{ width: '100%' }}>Signup</button>
      </form>
      <div style={{ marginTop: '1.25rem', fontSize: '0.85rem', textAlign: 'center', color: 'var(--cust-muted)' }}>
        Already have an account? <Link to="/login" style={{ textDecoration: 'underline' }}>Login</Link>
      </div>
    </div>
  );
};

export default ReveenSignup;
